module.exports = __webpack_public_path__ + "static/media/globe-green.51033892.svg";